import React, { FunctionComponent as FC, useRef, useEffect } from 'react';
import { ImpactViewTypes } from '../../../../../types/data';
import * as d3 from  "d3";
import _ from 'lodash';
import { caseType } from '../../../../../types/data.global';
import './index.scss';


interface MeanBarChartProps {
  chartTitle: string;
  data: ImpactViewTypes.AreaChartDataUnit[];
  width: number;
  height: number;
  color: string[];
  drawLabel: boolean;
}

interface MeanDataUnit {
    attributeName: string;
    mean: number;
}

const MeanBarChart: React.FC<MeanBarChartProps> = (props) => {
    const { chartTitle, data, width, height, color, drawLabel } = props

    const svgRef = useRef<SVGSVGElement>(null);

    useEffect(() => {
        if (!data || data.length === 0) return;

        const margin = { top: 5, right: 70, bottom: 10, left: 10 };
        const chartWidth  = Math.max(0, width - margin.left - margin.right);
        const chartHeight = Math.max(0, height - margin.top - margin.bottom);
        // const chartWidth = width - margin.left - margin.right;
        // const chartHeight = height - margin.top - margin.bottom;

        const svg = d3.select(svgRef.current)
        .attr('width', width)
        .attr('height', height);

        svg.selectAll('*').remove();

        const meanData: MeanDataUnit[] = data.flatMap(unit =>
            Object.keys(unit).map(key => ({
              attributeName: key,
              mean: d3.mean(unit[key]) || 0
            }))
          );
        console.log('chartTitle:', chartTitle);
        console.log('meanData:', meanData);

        const yScale = d3.scaleBand()
        .range([0, chartHeight])
        .domain(meanData.map(d => d.attributeName))
        .padding(0.2);

        const xMaxValue = d3.max(meanData, d => d.mean) || 0;
        const xMInValue = d3.min(meanData, d => d.mean) || 0;
        const xDiffValue = xMaxValue - xMInValue

        var hardCodeXMaxValue = Math.ceil(xMaxValue + 1.5 * xDiffValue)

        if (caseType == "case1") {
          // pass
        } else if (caseType == "case2") {
          if(chartTitle === "Scientific Impact Num Of Papers"){
              hardCodeXMaxValue = (20)
          }
          else if(chartTitle === "Scientific Impact Num Of Hit Papers"){
              hardCodeXMaxValue = (3)
          }
          else if(chartTitle === "Scientific Impact Num Of Disruptive Papers"){
              hardCodeXMaxValue = (0.60)
          }
        } else {
          console.warn("Unknown caseType:", caseType);
        }

        // if(chartTitle === "Scientific Impact Num Of Papers"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 15 : 20)
        // }
        // else if(chartTitle === "Scientific Impact Num Of Hit Papers"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 3 : 3)
        // }
        // else if(chartTitle === "Scientific Impact Num Of Disruptive Papers"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 0.60 : 0.60)
        // }
        // else if(chartTitle === "Marketplace Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 5 : 7.5)
        // }
        // else if(chartTitle === "Clinical Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 2 : 2)
        // }
        // else if(chartTitle === "Indirect Marketplace Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 0.3 : 6)
        // }
        // else if(chartTitle === "Indirect Clinical Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 0.3 : 0.3)
        // }
        // else if(chartTitle === "Policy Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 2 : 2)
        // }
        // else if(chartTitle === "Newsfeed Impact"){
        //     hardCodeXMaxValue = (caseType === "case1" ? 8 : 4)
        // }

        const xScale = d3.scaleLinear()
        .domain([0, hardCodeXMaxValue])
        .range([0, chartWidth]);

        const g = svg.append('g')
        .attr('transform', `translate(${margin.left},${margin.top})`);

        // 添加灰色背景
        g.append("rect")
            .attr("width", width)
            .attr("height", height)
            .attr("fill", "#F5F5F5")
            .attr("rx", 5) // 设置圆角半径
            .attr("ry", 5) // 设置圆角半径
            .attr("transform", `translate(${-margin.left}, ${-margin.top})`)
            .style("z-index", 0);
        // g.append('g')
        // .call(d3.axisLeft(yScale));

        // g.append('g')
        // .attr('transform', `translate(0,${chartHeight})`)
        // .call(d3.axisBottom(xScale).tickSize(1));

        g.append("g")
            .attr("class", "axis-hidden") // 添加隐藏类
            .attr("transform", `translate(0, ${chartHeight})`)
            .call(
                d3.axisBottom(xScale)
                .ticks(5)
                // .tickSize(2)
                .tickSize(-(height-margin.top-margin.bottom))
                .tickFormat(d3.format("0.2f"))
            )
            .call(g => g.select(".domain")
                .remove())
            .call(g => g.selectAll(".tick line")
                .attr("stroke-opacity", 0.5)
                .attr("stroke-dasharray", "2,2"))
            .selectAll("text") // 选择所有刻度文本
            .style("font-size", "6px") // 设置字体大小
            .style("color", "gray"); // 设置字体颜色

        // g.append("g")
        //     .attr("class", "axis-hidden") // 添加隐藏类
        //     .call(
        //         d3.axisLeft(yScale)
        //         .ticks(3)
        //         // .tickSize(0)
        //         .tickSize(-(width-margin.left-margin.right))
        //         // .tickFormat(d3.format("1d"))
        //     )
        //     .call(g => g.select(".domain")
        //         .remove())
        //     .call(g => g.selectAll(".tick line")
        //         .attr("stroke-opacity", 0)
        //         .attr("stroke-dasharray", "2,2"))
        //     .selectAll("text") // 选择所有刻度文本
        //     .style("font-size", "5px") // 设置字体大小
        //     .style("color", "gray"); // 设置字体颜色

        g.selectAll(".domain, .tick line") // 选择坐标轴线和刻度线
            .attr("stroke", "gray"); // 设置颜色

            svg.on("mouseenter", function() {
                svg.selectAll(".axis-hidden").style("opacity", 1); // 显示坐标轴
            })
            .on("mouseleave", function() {
                svg.selectAll(".axis-hidden").style("opacity", 0); // 隐藏坐标轴
            });


        meanData.forEach((unit, index) => {
            // console.log('unit', unit)
            const unitName = unit.attributeName;
            const meanValue = unit.mean;

            // 绘制箱型
            g.append('rect')
                .attr('x', xScale(0))
                .attr('y', yScale(unitName)!)
                .attr('width', xScale(meanValue))
                .attr('height', yScale.bandwidth())
                .attr('fill', color[index % color.length])
                .attr('fill-opacity', 0.8);
        });

        // 绘制图例
        if(drawLabel){
            const legend = g.append("g")
            .attr("transform", `translate(${chartWidth*1.05}, 0)`);

            meanData.forEach((unit, index) => {
                const legendRow = legend.append("g")
                    .attr("transform", `translate(0, ${index * 15})`);

                legendRow.append("rect")
                    .attr("width", 10)
                    .attr("height", 10)
                    .attr("fill", color[index] || "black");

                legendRow.append("text")
                    .attr("x", 15)
                    .attr("y", 8)
                    .style("font-size", "8px")
                    .text(unit.attributeName); // 假设图例文本是 unit 的键
            });
        }

    }, [data]);


    return (
        <div className="mean-barchart-chart-component">
        <svg ref={svgRef}></svg>
        </div>
    );
};


export default MeanBarChart;